(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jw-header"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.jw-menu-toggle').forEach(button => {
  const header = button.closest('.jw-header');
  const close = () => {
    header.classList.remove('is-menu-open');
    button.setAttribute('aria-expanded', 'false');
  };
  button.addEventListener('click', () => {
    const open = header.classList.toggle('is-menu-open');
    button.setAttribute('aria-expanded', String(open));
  });
  header.addEventListener('keydown', event => {
    if (event.key === 'Escape' && header.classList.contains('is-menu-open')) {
      close();
      button.focus();
    }
  });
  header.querySelector('.jw-nav').addEventListener('click', event => {
    if (event.target.closest('a')) close();
  });
  matchMedia('(max-width: 760px)').addEventListener('change', close);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
